module.exports = __webpack_public_path__ + "assets/img/faspay_723.8e32a510.png";